import { Grid, Space, Table } from "../components/Layout";
import { Media, ScrollTop, Title, Texts } from "../components/Object";
import { Head } from "../components/Project";
import { Scroll } from "../components/Animation";

const Company = () => {
  const googleMap = `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3292.511993755332!2d135.32596367718375!3d34.388330199906974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000c9ad977c3285%3A0xeee1eea850823867!2z44CSNTk4LTAwMjEg5aSn6Ziq5bqc5rOJ5L2Q6YeO5biC5pel5qC56YeO77yT77yX77yQ77yZ4oiS77yR!5e0!3m2!1sja!2sjp!4v1684745003431!5m2!1sja!2sjp" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
  
  return(
    <>
      <Head slug="company" />
    
      <div className="l-row">
        <Title slug="message"></Title>
        <Space size={['104px 0 0', '72px 0 0']}>
          <Scroll>
            <div className="c-grid__wrap--message">
              <Texts slug="message/title"></Texts>
              <Texts slug="message/body" class="c-text--med"></Texts>
            </div>
          </Scroll>
        </Space>
      </div>

      <Space size={['120px 0 160px', '80px 0 100px']}>
        <Media src="common/bottom-text-message" alt=" " class="p-img__back-text" />
      </Space>
    
      <div className="l-row">
        <Title slug="overview"></Title>
        <Table slug="overview" len="10"></Table>
      </div>

      <Space size={['160px 0 0', '100px 0 0']}>
        <div className="l-row">
          <Title slug="access"></Title>
          <Space size={['48px 0 0', '32px 0 0']}>
            <div className="c-grid__wrap--map">
              <Texts slug="access/body"></Texts>
              <div
                className="l-footer__wrap--map"
                dangerouslySetInnerHTML={{__html: googleMap}}
              />
            </div>
          </Space>
        </div>
      </Space>

      <ScrollTop></ScrollTop>
    </>
  )
}

export default Company;